/** Réglages du fond Voyageur (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    ambiance: {
        type: "choix", libelle: "Ambiance", defaut: "crepuscule",
        options: [
            {valeur: "crepuscule", libelle: "Crépuscule"},
            {valeur: "jour", libelle: "Jour"},
            {valeur: "nuit", libelle: "Nuit"},
            {valeur: "auto", libelle: "Automatique (selon les horaires du magasin)"},
        ],
        aide: "Automatique : jour, crépuscule puis nuit selon les heures réglées dans « Horaires de l'ambiance automatique » (carte Fond du bandeau).",
    },
    vitesse: {
        type: "nombre", libelle: "Vitesse du sol", min: 8, max: 160, pas: 4, defaut: 64, unite: "px/s",
        aide: "Les plans lointains défilent plus lentement que le sol : plus ils sont loin, moins ils bougent.",
    },
    allure: {
        type: "choix", libelle: "Allure du voyageur", defaut: "courir",
        options: [{valeur: "courir", libelle: "Il court"}, {valeur: "marcher", libelle: "Il marche"}],
    },
    voyageur: {
        type: "interrupteur", libelle: "Afficher le voyageur", defaut: true,
        aide: "Décocher pour ne garder que le paysage.",
    },
    cadence: {
        type: "nombre", libelle: "Cadence des pas (feuille personnalisée)", min: 2, max: 30, pas: 1, defaut: 8, unite: "images/s",
        aide: "Sans effet avec le voyageur d'origine, dont les pas suivent le sol. Un GIF à 120 ms par image : environ 8.",
    },
    hauteur: {
        type: "nombre", libelle: "Hauteur du voyageur", min: -12, max: 12, pas: 1, defaut: 0, unite: "px",
        aide: "Monte (positif) ou descend (négatif) le voyageur, en pixels d'art, pour poser les pieds sur le sol.",
    },
    taille: {
        type: "nombre", libelle: "Taille du voyageur (feuille personnalisée)", min: 0.5, max: 2, pas: 0.25, defaut: 1, unite: "×",
        aide: "Sans effet avec le voyageur d'origine. ×1 montre chaque case de la feuille (64 × 48) à sa taille réelle.",
    },
    cadrage: {
        type: "nombre", libelle: "Cadrage de la scène", min: 0, max: 28, pas: 1, defaut: 0, unite: "px",
        aide: "Descend toute la scène (paysage et voyageur), en pixels d'art : on voit moins de sol et plus de ciel. Utile surtout en pixel épais.",
    },
    detail: {
        type: "choix", libelle: "Finesse du pixel", defaut: "fin",
        options: [
            {valeur: "fin", libelle: "Fin : paysage complet"},
            {valeur: "epais", libelle: "Épais : gros plan sur l'horizon"},
        ],
        aide: "Épais montre deux fois plus gros, mais seulement la bande de l'horizon (sans ciel ni nuages).",
    },
};
